import getTodoFolderStore from './getTodoFolderStore';

export function getDefaultFolderId(): string {
    return getTodoFolderStore().defaultFolderId;
}
